const ADD_LICENSES_BASE_URL = 'https://www.procurify.com/add-licenses/'

export const buildAddLicensesUrl = ({
  domain,
  email,
}: {
  domain: string
  email: string
}): string => {
  const params = new URLSearchParams({
    utm_domain: domain,
    utm_email: email,
  })
  return `${ADD_LICENSES_BASE_URL}?${params.toString()}`
}
